export const CorporateAdditionalFilter = {
  Debut: 'debut',
  Hybrid: 'hybrid',
  Retail: 'retail',
  ReOpenTap: 'reOpenTap',
  Upsized: 'upsized',
  Marketing: 'marketing',
} as const;

export type TCorporateAdditionalFilter = typeof CorporateAdditionalFilter[keyof typeof CorporateAdditionalFilter];
